import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import ContactBox from '../components/ContactBox'

const Home = () => {
    return (
        <>
            <Navbar />
            <section className="sliderrr">
                <div className="main-silder">
                    <div id="slider" className="">
                        <div className="overlay">
                            <video className="img-fluid mx-auto bannerImg" alt="Banner Images" draggable="false" playsInline autoPlay={true} loop={true} muted >
                                <source src="/videos/mainbanner.mp4"  type="video/mp4" />
                            </video>
                            <div className="container">
                                <div className="silder">
                                    <div className="silder-text">
                                        <h2 className="text  Viga cl-w wow animate__flipInX" data-wow-delay="0s" data-wow-duration="1s">Welcome to Integro Exim</h2>
                                        <p className="txt  cl-w wow animate__lightSpeedInRight" data-wow-delay="0.2s" data-wow-duration="1s">At Integro Exim, we specialize in providing high quality dehydrated agricultural products to meet the
                                            diverse needs of global markets. Our network of reliable producers ensures that you receive fresh,
                                            sustainable, and competitively priced products.
                                        </p>
                                        <a href="/about" className="btn">Know More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mrg_tb">
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-6 my-3 my-lg-0 wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <img src="/images/About_Us_Image.png" alt="Image of About Us section" draggable="false" className="img-fluid" />
                        </div>
                        <div className="col-lg-6 my-3 my-lg-0 wow animate__fadeInLeft" data-wow-delay="0.5s" data-wow-duration="1s">
                            <h2 className="Viga ">About Us<span className="cl-theme"></span></h2>
                            <div className="cusLineH mt-2 pb-5">
                                Integro EXIM is a dynamic and forward-thinking import-export
                                company, dedicated to facilitating global trade by connecting
                                businesses with high quality products from around the world.
                                With a strong commitment to excellence and innovation, we
                                specialize in sourcing, exporting and importing a wide range
                                of goods across diverse industries, ensuring our clients receive
                                the best products, services, and solutions to meet their needs.
                            </div>
                            <a href="/about" className="cusBtn">Read More</a>
                        </div>
                    </div>
                </div>
            </section>

            <section id="ourProduct">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">What We Export<span className="cl-theme"></span></h2>
                        <div className="subHeading wow animate__fadeInDown" data-wow-delay="0.6s" data-wow-duration="1s">
                            Our Premium Dehydrated Agriculture Products
                        </div>
                    </div>

                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-md-6 col-lg-4 my-3 wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <a href="/spices" className="d-flex flex-column justify-content-center align-items-center cusScalHvr">
                                <img src="/images/home/spices.png" alt="Image of Spices" draggable="false" className="img-fluid" />
                                <h4 className="Viga mt-3">Spices</h4>
                                <div className="btnLink d-flex justify-content-center align-items-center">Shop all</div>
                            </a>
                        </div>
                        <div className="col-md-6 col-lg-4 my-3 wow animate__fadeInUp" data-wow-delay="0.2s" data-wow-duration="1s">
                            <a href="/onion" className="d-flex flex-column justify-content-center align-items-center cusScalHvr">
                                <img src="/images/home/onion.png" alt="Image of Spices" draggable="false" className="img-fluid" />
                                <h4 className="Viga mt-3">Onion Products</h4>
                                <div className="btnLink d-flex justify-content-center align-items-center">Shop all</div>
                            </a>
                        </div>
                        <div className="col-md-6 col-lg-4 my-3 wow animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="1s">
                            <a href="/garlic" className="d-flex flex-column justify-content-center align-items-center cusScalHvr">
                                <img src="/images/home/garlic.png" alt="Image of Spices" draggable="false" className="img-fluid" />
                                <h4 className="Viga mt-3">Garlic Products</h4>
                                <div className="btnLink d-flex justify-content-center align-items-center">Shop all</div>
                            </a>
                        </div>
                        <div className="col-md-6 col-lg-4 my-3 wow animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
                            <a href="/raisins" className="d-flex flex-column justify-content-center align-items-center cusScalHvr">
                                <img src="/images/home/raisins.png" alt="Image of Spices" draggable="false" className="img-fluid" />
                                <h4 className="Viga mt-3">Raisins (Dried Grapes)</h4>
                                <div className="btnLink d-flex justify-content-center align-items-center">Shop all</div>
                            </a>
                        </div>
                        <div className="col-md-6 col-lg-4 my-3 wow animate__fadeInUp" data-wow-delay="0.8s" data-wow-duration="1s">
                            <a href="/vegetable" className="d-flex flex-column justify-content-center align-items-center cusScalHvr">
                                <img src="/images/home/vegetable.png" alt="Image of Spices" draggable="false" className="img-fluid" />
                                <h4 className="Viga mt-3">Vegetable Powder</h4>
                                <div className="btnLink d-flex justify-content-center align-items-center">Shop all</div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mrg_tb">
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">Why Choose us<span className="cl-theme">?</span></h2>
                        <div className="subHeading  wow animate__fadeInDown" data-wow-delay="0.6s" data-wow-duration="1s">
                            Our global network spans multiple countries, including India, with a wide range of markets where we conduct business.
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-md-6 col-xl-3 my-3  wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <div className="ChooseCard">
                                <img src="/images/Excellence in Quality.png" alt="Excellence in Quality" draggable="false" className="img-fluid chooseIcon" />
                                <h5 className="Viga mt-3 mb-2">Excellence in Quality</h5>
                                <div className="chooseText">
                                    We are committed to delivering only the highest quality products. Our rigorous quality control
                                    processes ensure that every item meets international standards, providing you with reliable and
                                    superior goods for your business.
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3 my-3  wow animate__fadeInUp" data-wow-delay="0.2s" data-wow-duration="1s">
                            <div className="ChooseCard">
                                <img src="/images/Excellence in Service.png" alt="Excellence in Service" draggable="false" className="img-fluid chooseIcon" />
                                <h5 className="Viga mt-3 mb-2">Excellence in Service</h5>
                                <div className="chooseText">
                                    Our dedicated team goes above and beyond to provide exceptional customer service. From
                                    personalized support to prompt communication, we ensure a seamless experience for our clients at
                                    every stage of the export-import process.
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3 my-3  wow animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="1s">
                            <div className="ChooseCard">
                                <img src="/images/Global Logistics Expertise.png" alt="Global Logistics Expertise" draggable="false" className="img-fluid chooseIcon" />
                                <h5 className="Viga mt-3 mb-2">Global Logistics Expertise</h5>
                                <div className="chooseText">
                                    With a well-established international network, we facilitate trade across diverse markets. Our
                                    extensive connections allow us to source and distribute products efficiently, ensuring that your
                                    business can thrive in the global marketplace.
                                </div>

                            </div>
                        </div>
                        <div className="col-md-6 col-xl-3 my-3  wow animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
                            <div className="ChooseCard">
                                <img src="/images/Customer Engagement.png" alt="Customer Engagement" draggable="false" className="img-fluid chooseIcon" />
                                <h5 className="Viga mt-3 mb-2">Customer Engagement</h5>
                                <div className="chooseText">
                                    We focus on building strong connections with our clients. By providing personalized support and
                                    proactive communication, we ensure your needs are met, fostering lasting partnerships that drive your
                                    business success.
                                </div>

                            </div>
                        </div>

                    </div>

                </div>
            </section>

            <section>
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">Our Global Reach<span className="cl-theme">?</span></h2>
                        <div className="subHeading  wow animate__fadeInDown" data-wow-delay="0.6s" data-wow-duration="1s">
                            Delivering High Quality Dehydrated Agriculture Product Worldwide
                        </div>
                    </div>

                    <div className="row mt-3">

                        <div className="col-4 col-lg-2 d-flex flex-column justify-content-center align-items-center cusScalHvr my-3  wow animate__fadeInUp" data-wow-delay="0s" data-wow-duration="1s">
                            <img src="/images/Germany.png" alt="Flag of Germany" draggable="false" className="img-fluid" />
                            <div className="cl-51">Germany</div>
                        </div>
                        <div className="col-4 col-lg-2 d-flex flex-column justify-content-center align-items-center cusScalHvr my-3  wow animate__fadeInUp" data-wow-delay="0.2s" data-wow-duration="1s">
                            <img src="/images/UAE.png" alt="Flag of UAE" draggable="false" className="img-fluid" />
                            <div className="cl-51">UAE</div>
                        </div>
                        <div className="col-4 col-lg-2 d-flex flex-column justify-content-center align-items-center cusScalHvr my-3  wow animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="1s">
                            <img src="/images/USA.png" alt="Flag of USA" draggable="false" className="img-fluid" />
                            <div className="cl-51">USA</div>
                        </div>
                        <div className="col-4 col-lg-2 d-flex flex-column justify-content-center align-items-center cusScalHvr my-3  wow animate__fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
                            <img src="/images/UK.png" alt="Flag of UK" draggable="false" className="img-fluid" />
                            <div className="cl-51">UK</div>
                        </div>
                        <div className="col-4 col-lg-2 d-flex flex-column justify-content-center align-items-center cusScalHvr my-3  wow animate__fadeInUp" data-wow-delay="0.8s" data-wow-duration="1s">
                            <img src="/images/Japan.png" alt="Flag of Japan" draggable="false" className="img-fluid" />
                            <div className="cl-51">Japan</div>
                        </div>
                        <div className="col-4 col-lg-2 d-flex flex-column justify-content-center align-items-center cusScalHvr my-3  wow animate__fadeInUp" data-wow-delay="1s" data-wow-duration="1s">
                            <img src="/images/Canada.png" alt="Flag of Canada" draggable="false" className="img-fluid" />
                            <div className="cl-51">Canada</div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="mrg_tb">
                <div className="NumFixBG">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-4 d-flex flex-column justify-content-center align-items-center my-5 my-md-0  wow animate__fadeIn" data-wow-delay="0s" data-wow-duration="1s">
                                <div className="NumSize Viga"><span id="number1">30</span>+</div>
                                <div className="NumName">Country Covered</div>
                            </div>
                            <div className="col-md-4 d-flex flex-column justify-content-center align-items-center my-5 my-md-0  wow animate__fadeIn" data-wow-delay="0.2s" data-wow-duration="1s">
                                <div className="NumSize Viga"><span id="number2">50</span>+</div>
                                <div className="NumName">Worldwide Clients</div>
                            </div>
                            <div className="col-md-4 d-flex flex-column justify-content-center align-items-center my-5 my-md-0  wow animate__fadeIn" data-wow-delay="0.4s" data-wow-duration="1s">
                                <div className="NumSize Viga"><span id="number3">5</span>+</div>
                                <div className="NumName">Expert Company Staffs</div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container">

                    <div className="heading d-flex flex-column justify-content-center align-items-center mb-4">
                        <h2 className="Viga text-center  wow animate__flash" data-wow-delay="0s" data-wow-duration="1s">White Labelling<span className="cl-theme"></span></h2>
                    </div>

                    <div className="row">
                        <div className="col-12   wow animate__flipInX" data-wow-delay="0.6s" data-wow-duration="1s">
                            <div className="WhiteLabellingBox">
                                <div className="pt-4 px-3 px-md-5 pb-2 fw-medi">
                                    Integro Exim provides white labelling services that enable you to brand our premium products as your own. This solution allows you to
                                    expand your product offerings without the complexities of manufacturing. Trust us to handle sourcing and logistics while you focus on
                                    building your brand.
                                </div>
                                <img src="/images/White Labelling Packaging of IntegroExim.png" alt="White Labelling Packaging of IntegroExim" draggable="false" className="img-fluid w-100" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ContactBox></ContactBox>

            <Footer></Footer>
        </>
    )
}

export default Home